import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { PlainModal, StandardModalHeader } from "@design-system/Modal/Modal";

interface ConfirmDiscardScheduleChangesModalProps {
    show: boolean;
    isSaving: boolean;
    saveDisabled: boolean;
    onSave: () => void;
    onDiscard: () => void;
    onCancel: () => void;
}

export const ConfirmDiscardScheduleChangesModal: React.FC<
    ConfirmDiscardScheduleChangesModalProps
> = ({ show, isSaving, saveDisabled, onSave, onDiscard, onCancel }) => (
    <PlainModal show={show} onHide={onCancel} size="md">
        <StandardModalHeader>Unsaved changes</StandardModalHeader>
        <VStack gap={16} paddingBlock={4}>
            <div>You have unsaved changes. What would you like to do?</div>
        </VStack>
        <HStack as="footer" gap={12} justify="end">
            <Button
                type="button"
                variant="secondary"
                size="xl"
                onClick={onSave}
                disabled={isSaving || saveDisabled}
            >
                Save changes & exit
            </Button>
            <Button
                type="button"
                variant="destructive"
                size="xl"
                onClick={onDiscard}
                disabled={isSaving}
            >
                Discard changes
            </Button>
        </HStack>
    </PlainModal>
);
